import React, { useState, useEffect } from 'react';
import { formatDate } from '../utils';
import '../HomeBaseForm.css';
import '../Buttons.css';
import SupplierVarietyManager from './SupplierVarietyManager.js';
import SupplierStarterPreorder from './SupplierStarterPreorder.js';
import SUPJeopardyReport from './SUPJeopardyReport';
import SUPPullListReport from './SUPPullListReport';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandsClapping, faHeart, faComment } from '@fortawesome/free-solid-svg-icons';
import api from '../../api';
import imageCompression from 'browser-image-compression';

const SUPHomeBaseForm = ({ currentSupplier, onSelectCrop, selectedCrop, plants, handleTabChange, fetchCurrentSupplier, currentDate }) => {

        const [announcements, setAnnouncements] = useState([]);
        const [seasonalTasks, setSeasonalTasks] = useState([]);
        const [seasonalHeader, setSeasonalHeader] = useState([]);
        const [newCaption, setNewCaption] = useState('');
        const [imageFile, setImageFile] = useState(null);
        const [socialPosts, setSocialPosts] = useState([]);
        const [threadTitle, setThreadTitle] = useState('');
        const [showCommentForm, setShowCommentForm] = useState({});
        const [commentText, setCommentText] = useState({});
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showValidationErrors, setShowValidationErrors] = useState(false);
    const [showBuyerJeopardy, setShowBuyerJeopardy] = useState(false);
    const [showBuyerPullList, setShowBuyerPullList] = useState(false);

        const isThreadTitleEmpty = threadTitle.trim().length === 0;
        const isCaptionEmpty = newCaption.trim().length === 0;

        const isPostDisabled =
            isThreadTitleEmpty ||
            isCaptionEmpty;

    /*    useEffect(() => {
            if (!currentSupplier?.id) return;
            fetchCurrentSupplier();
        }, [currentSupplier?.id]); // is this causing the black screen? */

        useEffect(() => {
            if (currentSupplier?.isNewSupplier) {
                api.put(`/supplier/${currentSupplier.id}`, {
                    ...currentSupplier,
                    isNewSupplier: 0
                });
            }
        }, [currentSupplier?.isNewSupplier]);

        useEffect(() => {
            if (currentSupplier?.id) {
                fetchSeasonalHeader();
                fetchSeasonalTasks();
                fetchAnnouncements();
                fetchSocialPosts();
            }
        }, [currentSupplier?.id]);

        useEffect(() => {
            if (seasonalTasks.length > 1) {
                const interval = setInterval(() => {
                    setCurrentIndex((prev) => (prev + 1) % seasonalTasks.length);
                }, 5000); // change every 5 seconds
                return () => clearInterval(interval);
            }
        }, [seasonalTasks]);

        const fetchSeasonalTasks = async () => {
            if (!currentSupplier?.id) return;

            const supplierID = currentSupplier.id;

            try {
                const response = await api.get('/seasonalTips', {
                    params: {
                        supplierID,
                        currentDate
                    }
                });

                const data = response.data;
                setSeasonalTasks(data);
            } catch (err) {
                console.error('Error fetching seasonal tasks:', err);
            }
        };

        const fetchSeasonalHeader = async () => {
            if (!currentSupplier?.id) return;

            const supplierID = currentSupplier.id;

            try {
                const response = await api.get('/tasks/seasonal', {
                    params: {
                        supplierID,
                        currentDate,
                        scheduleTable: 'scheduleTask'
                    }
                });

                const data = response.data;
                setSeasonalHeader(data);
            } catch (err) {
                console.error('Error fetching seasonal tasks:', err);
            }
        };

        const fetchAnnouncements = async () => {
            try {
                const response = await api.get('/announcements', { params: { currentDate } });
                const data = response.data;
                setAnnouncements(data);
            } catch (err) {
                console.error('Error fetching announcements:', err);
            }
        };

        const loadMorePosts = async () => {
            const newOffset = socialPosts.length;

            try {
                const response = await api.get('/social/posts', {
                    params: {
                        limit: 50,
                        offset: newOffset
                    }
                });

                const morePosts = response.data;

                // Append older posts to the bottom
                setSocialPosts(prev => [...prev, ...morePosts]);

            } catch (err) {
                console.error("Error loading older posts:", err);
            }
        };


        const fetchSocialPosts = async () => {
            try {
                const response = await api.get('/social/posts');
                const data = response.data;
                setSocialPosts(data);
            } catch (err) {
                console.error('Error fetching social posts:', err);
            }
        };

        const handleAnnouncementDetails = (item) => {
            alert(`Details for "${item.Title}"\n\n${item.Description}`);
        };


        const handleImageUpload = async (e) => {
            const file = e.target.files[0];
            if (!file) return;

            try {
                const options = {
                    maxSizeMB: 0.15, // ~150 KB max 
                    maxWidthOrHeight: 800, // perfect for social feed 
                    initialQuality: 0.6,
                    useWebWorker: true
                };

                const compressedFile = await imageCompression(file, options);

                // Store the compressed file instead of the original
                setImageFile(compressedFile);

            } catch (error) {
                console.error("Image compression failed:", error);
                setImageFile(file); // fallback to original if compression fails
            }
        };

        const getImageUrl = (filename) =>
            `${process.env.REACT_APP_IMAGE_BASE_URL}/uploads/social/${filename}`;


        const handlePostSubmit = async (e) => {
            e.preventDefault();

            const titleEmpty = threadTitle.trim().length === 0;
            const captionEmpty = newCaption.trim().length === 0;

            if (titleEmpty || captionEmpty) {
                setShowValidationErrors(true);
                return;
            }

            setShowValidationErrors(false);

            const formData = new FormData();
            formData.append('caption', newCaption);
            formData.append('threadTitle', threadTitle);
            formData.append('image', imageFile);
            formData.append('supplierID', currentSupplier.id);

            try {
                const response = await api.post('/social/posts', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                const newPost = response.data;
                console.log('New post received from server:', newPost);
                console.log('Image filename from server:', newPost.imageFilename);

                setSocialPosts(prev => [newPost, ...prev]);
                setNewCaption('');
                setThreadTitle('');
                setImageFile(null);
            } catch (err) {
                console.error('Error submitting post:', err);
            }
        };

        const threads = socialPosts.reduce((acc, post) => {
            const title = post.threadTitle || 'Untitled';
            if (!acc[title]) acc[title] = [];
            acc[title].push(post);
            return acc;
        }, {});

        const toggleCommentForm = (postId) => {
            setShowCommentForm(prev => ({ ...prev, [postId]: !prev[postId] }));
        };

        const handleReaction = async (postId, type) => {
            try {
                const response = await api.post(`/social/posts/${postId}/react`, { type });
                const { loveCount, applauseCount } = response.data;

                setSocialPosts(prev =>
                    prev.map(post =>
                        post.id === postId
                            ? { ...post, loveCount, applauseCount }
                            : post
                    )
                );
            } catch (error) {
                console.error('Reaction failed:', error);
            }
        };

        const handleCommentSubmit = async (e, postId) => {
            e.preventDefault();
            const text = commentText[postId];
            if (!text) return;
            console.log('Submitting comment with:', {
                postId,
                text: commentText[postId],
                gardenerId: currentSupplier?.supplierID,
                currentSupplier
            });

            try {
                const response = await api.post(`/social/posts/${postId}/comments`, {
                    text,
                    supplierID: currentSupplier.id
                });

                const { comments } = response.data;
                setSocialPosts(prev =>
                    prev.map(p => (p.id === postId ? { ...p, comments } : p))
                );
                setCommentText(prev => ({ ...prev, [postId]: '' }));
            } catch (err) {
                console.error('Error submitting comment:', err);
            }
        };


        const renderSocialCard = (post) => {
            const imageUrl = getImageUrl(post.imageFilename);
            const commentValue = commentText[post.id] || "";
            const isCommentEmpty = commentValue.trim().length === 0;

            return (
                <div key={post.id} className="social-card">

                    {/* Header */}
                    <div className="card-header">
                        <div className="card-header-left">
                            <strong>{post.username}</strong>
                        </div>

                        <div className="card-header-center">
                            {post.threadTitle && (
                                <span className="card-thread-title">
                                    {post.threadTitle}
                                </span>
                            )}
                        </div>

                        <div className="card-header-right">
                            <span className="card-timestamp">
                                {formatDate(post.created_at)}
                            </span>
                        </div>
                    </div>

                    {/* Image */}
                    {post.imageFilename && (
                        <div className="card-image">
                            <img
                                src={imageUrl}
                                alt={`Post from ${post.username}`}
                            />
                        </div>
                    )}

                    {/* Body */}
                    <div className="card-body">

                        {/* Caption / Question */}
                        {post.caption && (
                            <p className="card-caption">{post.caption}</p>
                        )}

                        {/* Reactions */}
                        <div className="card-reactions">
                            <button
                                aria-label="React with clapping"
                                onClick={() => handleReaction(post.id, "applause")}
                                className="reaction-button"
                            >
                                <FontAwesomeIcon icon={faHandsClapping} />
                                <span className="reaction-count">
                                    {post.applauseCount ?? 0}
                                </span>
                            </button>

                            <button
                                aria-label="React with heart"
                                onClick={() => handleReaction(post.id, "love")}
                                className="reaction-button"
                            >
                                <FontAwesomeIcon icon={faHeart} />
                                <span className="reaction-count">
                                    {post.loveCount ?? 0}
                                </span>
                            </button>

                            <button
                                onClick={() => toggleCommentForm(post.id)}
                                aria-label="React with comment"
                                className="reaction-button"
                            >
                                <FontAwesomeIcon icon={faComment} />
                            </button>
                        </div>

                        {/* Comment Form */}
                        {showCommentForm[post.id] && (
                            <form
                                onSubmit={(e) => handleCommentSubmit(e, post.id)}
                                className="comment-form"
                            >
                                <input
                                    type="text"
                                    placeholder="Add a comment..."
                                    value={commentValue}
                                    onChange={(e) =>
                                        setCommentText((prev) => ({
                                            ...prev,
                                            [post.id]: e.target.value,
                                        }))
                                    }
                                />

                                <button
                                    type="submit"
                                    className="button"
                                    disabled={isCommentEmpty}
                                >
                                    Post
                                </button>

                            </form>
                        )}

                        {/* Comments */}
                        {post.comments?.length > 0 && (
                            <div className="card-comments">
                                {post.comments.map((comment, index) => (
                                    <div key={index} className="comment">
                                        <strong>{comment.commenter}</strong>:{" "}
                                        {comment.text}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            );
        };

        return (
            <div className="homebase-container" >
                <section className="compact-banner-grid">

                    <div className="banner-greeting">
                        <h2>Welcome back, {currentSupplier?.userName || 'Supplier'}!</h2>

                    </div>

                    <div className="banner-columns">
                        <div className="banner-column-seasonal">
                            <h3 className="banner-section-title">
                                {seasonalHeader.length > 0
                                    ? seasonalHeader[0].message   // now used as the header
                                    : 'Seasonal Tips'}
                            </h3>
                            <p>
                                {seasonalTasks.length > 0
                                    ? seasonalTasks[currentIndex].message
                                    : "No seasonal tips today - your garden's in great shape!"}
                            </p>
                        </div>

                        <div className="banner-column-announcement">
                            <h3 className="banner-section-title">Announcement</h3>
                            <p>
                                {announcements.length > 0
                                    ? announcements[0].Title
                                    : 'No announcements at the moment. Stay tuned for upcoming events!'}
                                {announcements.length > 0 && (
                                    <button
                                        className="details-button"
                                        onClick={() => handleAnnouncementDetails(announcements[0])}
                                    >
                                        More Details
                                    </button>
                                )}
                            </p>
                        </div>
                    </div>
                </section>

                <SupplierStarterPreorder
                    currentSupplier={currentSupplier}
                    currentDate={currentDate}
                />
                {currentSupplier?.role === "BUYER" && (
                    <div className="buyer-reports">
                        <h3>Reports</h3>

                        <button className="button" onClick={() => setShowBuyerJeopardy(true)}>
                            View Order Jeopardy Report
                        </button>

                        <button
                            className="button"
                            style={{ marginLeft: "10px" }}
                            onClick={() => setShowBuyerPullList(true)}
                        >
                            View Pull Sheet
                        </button>
                    </div>
                )}

                <section className="section-container task-section">
                    <SupplierVarietyManager
                        currentSupplier={currentSupplier}
                        currentDate={currentDate}
                        onSelectCrop={onSelectCrop}
                        selectedCrop={selectedCrop}
                        plants={plants }
                    />
                </section>


                <section className="post-composer" role="region" aria-labelledby="post-composer-title">
                    <h3 id="post-composer-title">Share Your Garden</h3>

                    <form onSubmit={handlePostSubmit} encType="multipart/form-data">

                        {/* Thread Topic */}
                        <div className="form-row">
                            <label htmlFor="thread-title-input">Thread Topic </label>
                            <input
                                id="thread-title-input"
                                type="text"
                                placeholder="Start a new topic or continue an existing one"
                                title="Start a new topic or continue an existing one"
                                value={threadTitle}
                                onChange={(e) => setThreadTitle(e.target.value)}
                            />
                        </div>

                        {/* Your Post */}
                        <div className="form-row">
                            <label htmlFor="caption-input">Your Post </label>
                            <input
                                id="caption-input"
                                type="text"
                                placeholder="Ask your question or share what�s happening in your garden"
                                title="Ask your question or share what�s happening in your garden"
                                value={newCaption}
                                onChange={(e) => setNewCaption(e.target.value)}
                            />
                        </div>

                        {/* Add a Photo */}
                        <div className="form-row">
                            <label htmlFor="image-upload">Add a Photo (optional) </label>
                            <input
                                id="image-upload"
                                type="file"
                                accept="image/*"
                                onChange={handleImageUpload}
                            />

                            {imageFile && (
                                <div className="image-preview">
                                    <p>Preview:</p>
                                    <img src={URL.createObjectURL(imageFile)} alt="Preview" width="200" />
                                </div>
                            )}
                        </div>

                        {/* Post Button */}
                        <div className="form-row">
                            <button type="submit" className="button">
                                Post
                            </button>

                            {/* Validation Errors */}
                            {showValidationErrors && (
                                <div className="post-errors" role="alert">
                                    {threadTitle.trim().length === 0 && (
                                        <p className="error-message">Please enter a thread topic.</p>
                                    )}
                                    {newCaption.trim().length === 0 && (
                                        <p className="error-message">Please enter your post.</p>
                                    )}
                                </div>
                            )}

                        </div>
                    </form>
                </section>

                <section className="section-container social-section" role="region" aria-labelledby="community-garden-title">
                    <h3 id="community-garden-title">Community Garden</h3>
                    {socialPosts.length > 0 ? (
                        <div className="social-cards">
                            {Object.entries(threads).map(([title, posts]) => (
                                <div key={title} className="thread-card">
                                    <h3 className="thread-title">{title}</h3>
                                    <div className="social-cards">
                                        {posts.map(post => renderSocialCard(post))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p>No posts yet - be the first to share your garden!</p>
                    )}
                    {/* Add a load older post button */}
                    <button className="button" onClick={loadMorePosts}> Load Older Posts </button>
                </section>
                {showBuyerJeopardy && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <button className="button" onClick={() => setShowBuyerJeopardy(false)}>
                                Close
                            </button>

                            <SUPJeopardyReport currentSupplier={currentSupplier} />
                        </div>
                    </div>
                )}

                {showBuyerPullList && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <button className="button" onClick={() => setShowBuyerPullList(false)}>
                                Close
                            </button>

                            <SUPPullListReport currentSupplier={currentSupplier} />
                        </div>
                    </div>
                )}

            </div>
        );
    };

export default SUPHomeBaseForm;
